import _slicedToArray from "/home/runner/work/neartrees/neartrees/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import * as e from "react";
export function useDirection(t, n) {
  var _e$useState = e.useState("ltr"),
      _e$useState2 = _slicedToArray(_e$useState, 2),
      r = _e$useState2[0],
      o = _e$useState2[1],
      _e$useState3 = e.useState(),
      _e$useState4 = _slicedToArray(_e$useState3, 2),
      i = _e$useState4[0],
      u = _e$useState4[1],
      c = e.useRef(0);

  return e.useEffect(function () {
    if (void 0 === n && null != t && t.parentElement) {
      var _e = getComputedStyle(t.parentElement);

      u(_e);
    }
  }, [t, n]), e.useEffect(function () {
    return void 0 === n && function e() {
      c.current = requestAnimationFrame(function () {
        var t = null == i ? void 0 : i.direction;
        t && o(t), e();
      });
    }(), function () {
      return cancelAnimationFrame(c.current);
    };
  }, [i, n, o]), n || r;
}